import React, { Component } from "react";
import {
  FooterButtons,
  MedBoxChecker,
} from "../../MarkOrder/CheckerOrderPage/CheckerOrderPage.styled";
import { Checkbox, Empty, Modal, Select, Tag, message } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import "./TOCheckerOrderPage.css";
import { RiErrorWarningLine } from "react-icons/ri";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { fetchTOMedicineDetailsForBoxThunk } from "../../../redux/CheckerTO/Action";
import TOOrderDetails from "../../../components/TOOrderDetails/TOOrderDetails";
import TMLoader from "../../../components/Loader/Loader";
import CheckerIssueModal from "./components/CheckerIssueModal";
import { verifyCheckerMedicineData } from "../../../components/Transfer Order/ToChecker/helper/helper";
import { SOMETHING_WENT_WRONG, warehouseId } from "../../../constants";
import { fetchCheckerBatchForBoxThunk } from "../../../redux/CheckerTO/Action";
import { Base64func } from "../../../components/Base64Func/Base64func";
import { RiExchangeFill } from "react-icons/ri";
const { Option } = Select;

export class TOCheckerOrderPage extends Component {
  state = {
    allMeds: [],
    selectedMed: {},
    batchModal: false,
    selectedQty: 0,
    qtyChanged: false,
    batchesById: [],
    checkedMeds: [],
    notCheckedMeds: [],
    medIssueModal: false,
    serviceLoading: false,
    isLastMeds: false,
    selectedChangeMed: null,
  };

  componentDidMount = () => {
    // get all batches from service
    this.fetchBatches();
  };

  fetchBatches = () => {
    if (this.props.match?.params?.toId && this.props.match?.params?.boxId) {
      this.setState({
        serviceLoading: true,
      });
      // fetch med details for box

      const params = {
        access_token: this.props.access_token,
        toNumber: Base64func(this.props.match.params.toId, "decode"),
        boxNumber: Base64func(this.props.match.params.boxId, "decode"),
        warehouseId: warehouseId,
        // warehouseId: 3,
      };

      this.props.fetchCheckerBatchForBoxThunk(params).then(() => {
        this.setState({
          serviceLoading: false,
        });
        if (this.props.checkerTO.batchesErr) {
          message.error(this.props.checkerTO.batchesErr);
        } else {
          this.getMedDetailsForBox();
        }
      });
    } else {
      message.error("Invalid TO Id or BOX ID");
    }
  };

  getMedDetailsForBox = () => {
    if (this.props.match?.params?.toId && this.props.match?.params?.boxId) {
      this.setState({
        serviceLoading: true,
      });
      // fetch med details for box
      const params = {
        access_token: this.props.access_token,
        toNumber: Base64func(this.props.match.params.toId, "decode"),
        boxNumber: Base64func(this.props.match.params.boxId, "decode"),
      };
      this.props.fetchTOMedicineDetailsForBoxThunk(params).then(() => {
        this.setState({
          serviceLoading: false,
        });
        if (this.props.checkerTO.medDetailsForBoxError) {
          message.error(this.props.checkerTO.medDetailsForBoxError);
        } else if (
          this.props.checkerTO.medDetailsForBox?.medicineDetailsDtoList
            ?.length > 0
        ) {
          this.setState({
            allMeds: this.props.checkerTO.medDetailsForBox
              .medicineDetailsDtoList,
          });

          this.selectedMed(
            this.props.checkerTO.medDetailsForBox.medicineDetailsDtoList,
            this.props.checkerTO?.batchesData?.item_stock
          );
        }
      });
    } else {
      message.error("Invalid TO Id or BOX ID");
    }
  };

  handleMedChangeSelect = (lineId) => {
    const { allMeds } = this.state;
    const allBatches = this.props.checkerTO?.batchesData?.item_stock;
    const changedMed = allMeds.find((e) => e.lineId === lineId);
    if (changedMed) {
      const selectedMed = {
        ...changedMed,
        batches: this.preSelectBatches(allBatches, changedMed),
      };

      this.setState(
        {
          selectedQty: 0,
          selectedMed: selectedMed,
          batchesById: selectedMed?.batches,
          showChangeMedicine: false,
          handleMedChangeSelect: null,
        },
        () => {
          this.preSetBatchQty();
        }
      );
    }
  };

  selectedMed = async (allMeds, allBatches) => {
    // set meds which has checked as true
    const checkedMeds = await allMeds.filter((med) => med.checked === true);
    // set meds which has checked as false
    const notCheckedMeds = await allMeds.filter((med) => med.checked === false);
    // const notCheckedMeds = await allMeds;
    // set select med with batches which will be dispalyed to the user\
    if (notCheckedMeds?.length === 1) {
      this.setState({ isLastMeds: true });
    }

    const selectedMed = {
      ...notCheckedMeds[0],
      batches: this.preSelectBatches(allBatches, notCheckedMeds[0]),
    };

    this.setState(
      {
        selectedQty: 0,
        selectedMed: selectedMed,
        checkedMeds: checkedMeds,
        notCheckedMeds: notCheckedMeds,
        batchesById: selectedMed?.batches,
      },
      () => {
        this.preSetBatchQty();
      }
    );
  };

  preSelectBatches = (allBatches, med) => {
    let selectedBatches = [];
    let temp = [];
    let isProductBlocked = false;
    let nsItemId = null;

    if (allBatches?.length > 0) {
      for (let i in allBatches) {
        let batch = allBatches[i];
        if (batch?.product_code === med?.productCode) {
          temp = batch.batches;
          nsItemId = batch.ns_item_id;
          isProductBlocked = batch.isProductBlocked
            ? batch.isProductBlocked
            : false;
          break;
        }
      }
      if (temp?.length > 0) {
        for (let i in temp) {
          let tempObj = {};
          let batch = temp[i];
          tempObj.batchNumber = batch.batch_number;
          tempObj.expiryNearBy = batch.expiryNearBy;
          tempObj.isBatchBlocked = batch.isBatchBlocked
            ? batch.isBatchBlocked
            : false;
          tempObj.isProductBlocked = isProductBlocked;
          tempObj.nsItemId = nsItemId;
          tempObj.expiryDate = batch.expiry_date;
          tempObj.maxQty = Number(batch.quantity);
          tempObj.mrp = batch.mrp;
          tempObj.rate = batch.rate;
          // tempObj.manufacturer_date = batch.manufacturer_date;
          // tempObj.external_batch_number = batch.external_batch_number;
          tempObj.checkedQty = 0;
          tempObj.issueQty = 0;
          tempObj.isPickSelect = false;
          tempObj.active = false;
          tempObj.reasonId = null;
          tempObj.selected = false;
          tempObj.enabled = false;
          tempObj.toNumber = Base64func(this.props.match.params.toId, "decode");
          tempObj.boxNumber = Base64func(
            this.props.match.params.boxId,
            "decode"
          );
          tempObj.productCode = med.productCode;
          tempObj.skuName = med.skuName;
          tempObj.quantity = med.quantity;
          tempObj.lineId = med.lineId;
          tempObj.checkerId = this.props.checkerTO.medDetailsForBox?.checkerId;
          tempObj.checkerName = this.props.checkerTO.medDetailsForBox?.checkerName;
          tempObj.ordervalue = this.props.checkerTO.medDetailsForBox?.ordervalue;
          selectedBatches.push(tempObj);
        }
      }
      if (selectedBatches?.length > 0) {
        // sorting batches based on isBatchBlocked, expiryNearBy & maxQty
        selectedBatches = selectedBatches?.sort((a, b) => {
          if (a.isBatchBlocked === false && b.isBatchBlocked === true) {
            return -1;
          } else if (a.isBatchBlocked === true && b.isBatchBlocked === false) {
            return 1;
          } else {
            if (a.expiryNearBy === false && b.expiryNearBy === true) {
              return -1;
            } else if (a.expiryNearBy === true && b.expiryNearBy === false) {
              return 1;
            }
            return b.maxQty - a.maxQty;
          }
        });
      }
    }
    return selectedBatches;
  };

  preSetBatchQty = () => {
    // pre selecting the batches for the selected med
    let arr = this.state.selectedMed?.batches;
    let rQty = this.state.selectedMed?.quantity;
    let sQty = this.state.selectedQty;
    for (let i in arr) {
      let batch = arr[i];
      if (rQty !== sQty) {
        if (rQty - sQty > batch.maxQty) {
          batch.checkedQty = batch.maxQty;
        } else {
          batch.checkedQty = rQty - sQty;
        }
        sQty = sQty + batch.checkedQty;
        batch.selected = !batch.isBatchBlocked;
        batch.enabled = true;
      }
    }
    let finalArr = [];
    for (let i in arr) {
      let b = arr[i];
      if (b.checkedQty > 0) {
        finalArr.push(b);
      }
    }
    let med = this.state.selectedMed;
    if (med) {
      med.batches = finalArr;
      this.setState({ selectedQty: sQty, selectedMed: med });
    }
  };

  calcSelectedQty = (arr) => {
    let totalQty = 0;
    for (let i in arr) {
      let b = arr[i];
      if (b.selected && b.checkedQty > 0) {
        totalQty = totalQty + b.checkedQty;
      }
    }
    return totalQty;
  };

  changeBatchOrPack = () => {
    this.setState(
      {
        selectedQty: this.calcSelectedQty(this.state.selectedMed.batches),
      },
      () => {
        this.setState({
          batchModal: true,
        });
      }
    );
  };

  onChangeBatchSelect = (e) => {
    this.setState({ qtyChanged: true });
    let checked = e.target.checked;
    let arr = this.state.batchesById;
    arr[e.target.value].selected = e.target.checked;
    if (!checked) {
      arr[e.target.value].checkedQty = 0;
    }
    this.setState(
      {
        selectedQty: this.calcSelectedQty(arr),
      },
      () => {
        if (this.state.selectedMed.quantity !== this.state.selectedQty) {
          this.setState({ batchesById: this.enableAllBatches(arr) });
        } else {
          this.setState({ batchesById: arr });
        }
      }
    );
  };

  enableAllBatches = (batches) => {
    let finalArr = batches;
    for (let i in finalArr) {
      let batch = finalArr[i];
      batch.enabled = true;
    }
    return finalArr;
  };

  changeBatchQty = (e, batchNo, maxQty) => {
    this.setState({ qtyChanged: true });
    const inputValue = e.target.value;
    const numericValue = inputValue.replace(/^0+(?=\d)/, "");
    if (Number(numericValue) > Number(maxQty)) {
      message.error("Max QTY is " + maxQty);
    } else {
      let arr = this.state.batchesById;
      for (let i in arr) {
        let b = arr[i];
        if (b.batchNumber === batchNo) {
          b.checkedQty = Number(numericValue);
        }
      }
      this.setState(
        {
          batchesById: arr,
          selectedQty: this.calcSelectedQty(arr),
        },
        () => {
          if (this.state.selectedMed.quantity !== this.state.selectedQty) {
            this.setState({ batchesById: this.enableAllBatches(arr) });
          }
        }
      );
    }
  };

  updateBatches = (batches) => {
    let med = this.state.selectedMed;
    let finalArr = [];
    for (let i in batches) {
      let b = batches[i];
      if (b.checkedQty > 0) {
        finalArr.push(b);
      }
    }
    med.batches = finalArr;
    if (med?.batches?.length > 0) {
      this.setState({ selectedMed: med }, () => {
        this.setState({ batchModal: false, qtyChanged: false });
      });
    } else {
      message.error("Please select batches");
    }
  };

  disableVerifyBtn = () => {
    let disabledBatches = [];
    let disableMed = false;

    this.state.selectedMed?.batches?.map((k) =>
      k.ogQty > 0 && k.isBatchBlocked ? disabledBatches.push(k) : null
    );

    this.state.selectedMed?.batches?.filter((k) => k.isProductBlocked)?.length >
    0
      ? (disableMed = true)
      : (disableMed = false);

    let isDisable =
      this.props.isLoading ||
      !this.state.selectedMed ||
      !this.state.selectedMed?.batches ||
      this.state.selectedMed?.batches?.length === 0 ||
      disabledBatches.length > 0 ||
      disableMed;

    return isDisable;
  };

  verifyMed = () => {
    const params = {
      access_token: this.props.access_token,
      data: this.state.selectedMed?.batches,
    };
    this.setState(
      {
        serviceLoading: true,
      },
      () => {
        verifyCheckerMedicineData(params)
          .then((res) => {
            this.setState({
              serviceLoading: false, //committed by jignesh
            });
            if (res?.status === 200) {
              message.success("Medicine verified successfully");
              if (this.state.isLastMeds) {
                this.props.history.push(
                  `/to-checker-box-process/${this.props.match?.params?.toId}`
                );
              } else {
                this.getMedDetailsForBox();
              }
            } else {
              throw new Error(res.data.message);
            }
          })
          .catch((err) => {
            this.setState({
              serviceLoading: false,
            });
            message.error(err.message || SOMETHING_WENT_WRONG);
          });
      }
    );
    // verifyCheckerMedicineData(data) service call & then
    // if lastMed is true then go to box list page
    // else
    // this.getMedDetailsForBox();
  };

  render() {
    let { checkerTO, warehouseList } = this.props;
    let { serviceLoading, medIssueModal, allMeds } = this.state;
    let filteredMeds = allMeds.filter((med) => med.checked === false);
    return (
      <div>
        {serviceLoading ? <TMLoader /> : null}

        <div>
          <TOOrderDetails
            toData={checkerTO?.medDetailsForBox}
            warehouseList={warehouseList}
            boxNumber={checkerTO?.medDetailsForBox?.boxNumber}
            isChecker
          />

          {/* <span>Transfer Order Number: 98099</span> */}
        </div>
        <MedBoxChecker>
          <div className={`medName`}>
            {this.state.selectedMed?.skuName}
            {filteredMeds.length > 0 ? (
              <div
                title={"Change Medicine"}
                className="medChangeDropdown"
                onClick={() => {
                  this.setState({
                    showChangeMedicine: true,
                  });
                }}
              >
                <RiExchangeFill />
              </div>
            ) : (
              ""
            )}
          </div>

          <div>
            <p className="title">Batch Name</p>
            <p className="title">MRP</p>
            <p className="title">QTY</p>
          </div>

          {this.state.selectedMed?.batches?.length > 0 ? (
            this.state.selectedMed?.batches?.map((item, pos) => (
              <div className="batchList" key={pos}>
                <p>
                  {item.batchNumber}
                  <span className="warn">Exp. {item.expiryDate}</span>
                  {item?.isBatchBlocked ? (
                    <Tag icon={<CloseCircleOutlined color="error" />}>
                      Batch blocked!
                    </Tag>
                  ) : null}
                </p>
                <p>₹{item.mrp}</p>
                <p>{item.checkedQty}</p>
              </div>
            ))
          ) : (
            <Empty
              style={{ margin: "5vh 0", display: "flex", flexFlow: "column" }}
              description="No Batches found"
            />
          )}

          {this.state.selectedMed?.batches?.length > 0 ? (
            <div
              className="editContainer"
              onClick={() => this.changeBatchOrPack()}
            >
              <p>Change Batch</p>
            </div>
          ) : null}
        </MedBoxChecker>
        <FooterButtons>
          <button
            className="bbtn"
            onClick={() => {
              this.setState({
                medIssueModal: true,
              });
            }}
            // disabled={!this.state.selectedMed || this.props.isLoading}
            // onClick={() => this.setState({ medIssueModal: true })}
          >
            <RiErrorWarningLine /> Update Medicine
          </button>

          <button
            className="bbtn"
            onClick={this.verifyMed}
            disabled={this.disableVerifyBtn()}
          >
            Verify
          </button>
        </FooterButtons>

        {medIssueModal ? (
          <CheckerIssueModal
            view={medIssueModal}
            close={(value) =>
              this.setState({
                medIssueModal: value,
              })
            }
            togglePageLoading={(value) =>
              this.setState({ serviceLoading: value })
            }
            selectedMed={this.state.selectedMed}
            toId={Base64func(this.props.match?.params?.toId, "decode")}
            boxId={Base64func(this.props.match?.params?.boxId, "decode")}
          />
        ) : null}

        <Modal
          centered
          title="Change Medicine"
          open={this.state.showChangeMedicine}
          footer={null}
          onCancel={() => this.setState({ showChangeMedicine: false })}
        >
          <div className="changeMedicineWrapper">
            <Select
              placeholder="Select Medicine"
              style={{ width: "100%" }}
              onChange={(e) => this.handleMedChangeSelect(e)}
              value={this.state.selectedChangeMed}
            >
              {this.state.allMeds
                .filter((med) => med.checked === false)
                .map((e) => {
                  return <Option value={e.lineId}>{e.skuName}</Option>;
                })}
            </Select>
          </div>
        </Modal>
        <Modal
          wrapClassName="updateMedBatchModal"
          title="Update Medicine Batch"
          open={this.state.batchModal}
          footer={null}
          onCancel={() => this.setState({ batchModal: false })}
          closable={!this.state.qtyChanged}
        >
          <div className="updateMedBatchContainer">
            <div className="updateMedBatchTable">
              <div className="updateMedBatchTitle">Batch Name</div>
              <div
                style={{ textAlign: "center" }}
                className="updateMedBatchTitle"
              >
                QTY
              </div>
              {this.state.batchesById?.length > 0 &&
                this.state.batchesById.map((batch, pos) =>
                  batch.maxQty > 0 ? (
                    <>
                      <div
                        style={{
                          border:
                            this.state.batchesById.length === pos + 1
                              ? "none"
                              : "",
                        }}
                        className="updateMedBatchName"
                      >
                        <Checkbox
                          disabled={
                            (!batch.enabled && batch?.isBatchBlocked) ||
                            batch?.expiryNearBy ||
                            batch?.isBatchBlocked
                          }
                          checked={batch.selected}
                          value={pos}
                          onChange={this.onChangeBatchSelect}
                        >
                          <span>{batch.batchNumber}</span>
                        </Checkbox>
                      </div>
                      <div
                        style={{
                          border:
                            this.state.batchesById.length === pos + 1
                              ? "none"
                              : "",
                        }}
                        className="updateMedBatchQty"
                      >
                        <input
                          className="batchQtyInput"
                          type="number"
                          name="checkedQty"
                          value={batch.checkedQty}
                          min={0}
                          max={batch.maxQty}
                          disabled={!batch.selected || batch?.isBatchBlocked}
                          onChange={(e) =>
                            this.changeBatchQty(
                              e,
                              batch.batchNumber,
                              batch.maxQty
                            )
                          }
                        />
                      </div>
                    </>
                  ) : null
                )}
            </div>
            <div className="updateMedBatchQtyFullfilled">
              {this.state.selectedQty === this.state.selectedMed?.quantity ? (
                <p>
                  Quantity fullfilled : <span>{this.state.selectedQty}</span> /{" "}
                  {this.state.selectedMed?.quantity}
                </p>
              ) : (
                <p style={{ color: "#E55934" }}>
                  Quantity conflict : <span>{this.state.selectedQty}</span> /{" "}
                  {this.state.selectedMed?.quantity}
                </p>
              )}
              <button
                className="bbtn"
                disabled={
                  this.state.selectedQty === this.state.selectedMed?.quantity
                    ? false
                    : true
                }
                onClick={() => this.updateBatches(this.state.batchesById)}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  checkerTO: state.checkerTOReducer,
  warehouseList: state.authReducer?.AuthData?.warehouseList,
});

export default withRouter(
  connect(mapStateToProps, {
    fetchTOMedicineDetailsForBoxThunk,
    fetchCheckerBatchForBoxThunk,
  })(TOCheckerOrderPage)
);
